import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { PRODUCTS } from "../mock";
import { useCart } from "../context/CartContext";

const LeafIcon = () => (
  <svg width="38" height="38" viewBox="0 0 56 56" className="mx-auto">
    <path
      d="M28 10 C18 16, 14 28, 22 40 C18 32, 22 22, 28 18 C34 22, 38 32, 34 40 C42 28, 38 16, 28 10 Z"
      fill="#c8232c"
    />
  </svg>
);

const ProductCard = ({ p, onOpen, onAdd }) => (
  <div className="product-card group bg-white">
    <button onClick={() => onOpen(p)} className="block w-full text-left">
      <div className="img-wrap relative overflow-hidden bg-stone-50 aspect-square">
        <img
          src={p.image}
          alt={p.name}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          {p.badges?.map((b) => (
            <span
              key={b}
              className="text-[10px] tracking-widest uppercase bg-white/95 text-stone-800 px-2 py-1 border border-stone-200"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </button>
    <div className="text-center pt-5 pb-3">
      <div className="text-[11px] tracking-[0.3em] uppercase text-stone-500">{p.short}</div>
      <h3 className="font-display text-2xl md:text-[26px] text-[#c8232c] mt-1">{p.name}</h3>
      <p className="text-sm text-stone-600 mt-2 px-4 leading-relaxed line-clamp-2">{p.blurb}</p>
      <div className="mt-4 flex items-center justify-center gap-4">
        <span className="text-stone-900 font-semibold">€{p.price.toFixed(2)}</span>
        <span className="text-xs text-stone-500">{p.weight}</span>
      </div>
      <button
        onClick={() => onAdd(p)}
        className="mt-4 btn-ghost text-xs tracking-[0.18em] uppercase inline-flex items-center gap-2"
      >
        <ShoppingBag size={14} /> Add to cart
      </button>
    </div>
  </div>
);

const Products = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();

  return (
    <section id="products" className="py-20 lg:py-28 bg-stone-50/50">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <LeafIcon />
          <h2 className="font-display text-4xl md:text-5xl text-[#c8232c] mt-4">
            Discover our nuts
          </h2>
          <div className="nut-divider" />
          <p className="mt-4 text-stone-600 max-w-xl mx-auto">
            From California almonds to Sicilian pistachios — a curated selection of nature&apos;s
            most nourishing little treasures.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {PRODUCTS.slice(0, 8).map((p) => (
            <ProductCard
              key={p.id}
              p={p}
              onOpen={(prod) => navigate(`/product/${prod.slug}`)}
              onAdd={(prod) => addItem(prod, 1)}
            />
          ))}
        </div>

        <div className="text-center mt-14">
          <button onClick={() => navigate("/shop")} className="btn-primary">
            See all our nuts
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;
